export const formatCurrency = (amount: number, currency: string = 'USD'): string => {
  // Handle undefined, null, or NaN values
  if (amount == null || isNaN(amount)) {
    return `${currency} 0.00`;
  }
  
  if (amount >= 1000000) {
    return `${currency} ${(amount / 1000000).toFixed(1)}M`;
  } else if (amount >= 1000) {
    return `${currency} ${(amount / 1000).toFixed(1)}K`;
  } else {
    return `${currency} ${amount.toFixed(2)}`;
  }
};

export const formatNumber = (value: number, decimals: number = 0): string => {
  if (value == null || isNaN(value)) {
    return '0';
  }
  return value.toLocaleString(undefined, { 
    minimumFractionDigits: decimals, 
    maximumFractionDigits: decimals 
  });
};

export const formatPercentage = (value: number, decimals: number = 1): string => {
  if (value == null || isNaN(value)) {
    return '0.0%';
  }
  return `${value.toFixed(decimals)}%`;
};

const PRESERVED_ACRONYMS = new Set([
  'AI', 'ML', 'API', 'UI', 'UX', 'ID', 'NPI', 'CPT', 'ICD', 'DRG',
  'HCPCS', 'LOS', 'YTD', 'MTD', 'QTD', 'USD', 'SAR', 'AED', 'EUR',
  'GBP', 'ROI', 'TAT', 'IP', 'OP', 'CO', 'HR'
]);

const MINOR_WORDS = new Set(['and', 'or', 'of', 'for', 'in', 'to', 'with', 'by', 'at', 'on', 'the', 'a', 'an']);

/**
 * Converts uppercase/snake_case words (e.g. "PAYER", "POST_OFFICE") to clean Title Case ("Payer", "Post Office")
 * while preserving standard domain acronyms (e.g., "AI", "CPT", "ICD", "USD").
 */
export const toTitleCase = (input: string | null | undefined): string => {
  if (!input) return '';
  const clean = input.replace(/[_-]+/g, ' ').trim();
  const words = clean.split(/\s+/);

  return words
    .map((word, index) => {
      const upper = word.toUpperCase();
      if (PRESERVED_ACRONYMS.has(upper)) {
        return upper;
      }
      const lower = word.toLowerCase();
      if (index > 0 && MINOR_WORDS.has(lower)) {
        return lower;
      }
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
};

